module.exports = __webpack_public_path__ + "img/pricing_hero_mobile.931db1a1.jpg";